if (!customElements.get('filazoo-description-toggle')) {
  customElements.define(
    'filazoo-description-toggle',
    class FilazooDescriptionToggle extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('[data-description-content]');
        this.button = this.querySelector('[data-description-toggle]');
        this.label = this.querySelector('[data-description-toggle-label]');
        if (!this.content || !this.button) return;

        this.expanded = false;
        this.onClick = this.onClick.bind(this);
        this.onTransitionEnd = this.onTransitionEnd.bind(this);
        this.sync = this.sync.bind(this);

        this.button.addEventListener('click', this.onClick);
        this.content.addEventListener('transitionend', this.onTransitionEnd);

        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.sync);
          this.observer.observe(this.content.firstElementChild || this.content);
        } else {
          window.addEventListener('resize', this.sync);
        }

        this.sync();
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
        this.content?.removeEventListener('transitionend', this.onTransitionEnd);
        this.observer?.disconnect();
        window.removeEventListener('resize', this.sync);
      }

      get collapsedHeight() {
        return Number(this.dataset.collapsedHeight) || 160;
      }

      /* Decide whether the description is long enough to be worth collapsing. */
      sync() {
        if (this.expanded) return;

        const fullHeight = this.content.scrollHeight;
        const needsToggle = fullHeight > this.collapsedHeight + 24;

        this.classList.toggle('is-collapsible', needsToggle);
        this.button.hidden = !needsToggle;
        this.content.style.maxHeight = needsToggle ? `${this.collapsedHeight}px` : '';
      }

      onClick() {
        if (this.expanded) {
          this.collapse();
        } else {
          this.expand();
        }
      }

      expand() {
        this.expanded = true;
        this.content.style.maxHeight = `${this.content.scrollHeight}px`;
        this.classList.add('is-expanded');
        this.button.setAttribute('aria-expanded', 'true');
        if (this.label) this.label.textContent = this.button.dataset.labelLess || 'Read less';
      }

      collapse() {
        this.expanded = false;
        // Lock in the current height first so the transition has somewhere to start from.
        this.content.style.maxHeight = `${this.content.scrollHeight}px`;
        this.content.getBoundingClientRect();

        requestAnimationFrame(() => {
          this.classList.remove('is-expanded');
          this.content.style.maxHeight = `${this.collapsedHeight}px`;
        });

        this.button.setAttribute('aria-expanded', 'false');
        if (this.label) this.label.textContent = this.button.dataset.labelMore || 'Read more';

        // Keep the toggle in view when a long description folds back up.
        const top = this.getBoundingClientRect().top;
        if (top < 0) window.scrollBy({ top: top - 24, behavior: 'smooth' });
      }

      onTransitionEnd(event) {
        if (event.target !== this.content || event.propertyName !== 'max-height') return;
        // Release the height cap once open so later content changes are not clipped.
        if (this.expanded) this.content.style.maxHeight = 'none';
      }
    }
  );
}
